export enum SlTpEnum {
	STOP_LOSS = 'stopLoss',
	TAKE_PROFIT = 'takeProfit',
}
